import * as angular from 'angular';
import * as _ from 'lodash';
import * as d3 from 'd3';

import { ComponentDefinition, Group, TreeType } from '../../models';
import { Store, StoreElement } from '../../stateManagement';
import { IGroupService, IStoreService } from '../../services';
import { getModel, Level, getChildren, DropDownItem } from './getModel';

class GroupsBreadCrumbController implements angular.IComponentController, angular.IOnInit, angular.IOnDestroy {
    selectedGroup: Group;
    tree: TreeType[] = [];
    byLevel: { key: string; values: TreeType[] }[] = [];
    levels: Level[] = [];
    children: DropDownItem[] = [];

    private _unsubscribe: () => void;

    static $inject = ['$state', 'storeService', 'groupService'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _storeService: IStoreService,
        private _groupService: IGroupService
    ) {
    }

    $onInit() {
        this._unsubscribe = this._storeService.register(
            store => this.safeReloadStore(store),
            [StoreElement.Groups]
        );
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedGroup'] && changesObj['selectedGroup'].currentValue) {
            this.refresh();
        }
    }

    $onDestroy(): void {
        this._unsubscribe();
    }

    private refresh() {
        this.levels = getModel(this.selectedGroup, this.tree, this.byLevel, this._$state.current.name);
        this.children = getChildren(this.selectedGroup, this.tree, this.byLevel, this._$state.current.name);
    }

    // This code has been introduced by #31836 trying to fix a "sometimes" dissapearing of breadcrumb
    private safeReloadStore(store: Store) {
        try {
            this.loadStore(store);
        } catch (e) {
            console.error('An error occured while loading group breadcrumb, trying to force reload.');
            console.error(e);
            // force reload of all groups to provoke recompute
            this._storeService.dispatchers().groups.getAll(true);
        }
    }

    private loadStore(store: Store) {
        const list = _.values<Group>(store.groups.dictionary).map(g => Object.assign({}, g));
        const tree: TreeType[] = this._groupService.convertToTree(list) as any[];
        const byLevel = d3.nest<TreeType>()
            .key(d => d.depth.toString())
            .entries(tree);

        this.tree = tree;
        this.byLevel = byLevel;
        this.refresh();
    }
}

export const wtGroupsBreadCrumb: ComponentDefinition = {
    componentId: 'wtGroupsBreadCrumb',
    controller: GroupsBreadCrumbController,
    template: require('./groupsBreadCrumb.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedGroup: '<'
    }
};
